<template>
  <el-dialog
    :title="link.id ? 'Редактирование ссылки' : 'Создание новой ссылки'"
    :visible.sync="show"
    width="30%"
    :close-on-click-modal="false"
  >
    <el-form
      size="small"
      ref="editForm"
      label-position="top"
      :model="link"
      :rules="linkRules"
      @submit.native.prevent="saveLink"
    >
      <el-form-item label="Отображаемое название" prop="name">
        <el-input
          maxlength="255"
          v-model="link.name"
          ref="nameToFocus"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="Адрес страницы" prop="url">
        <el-input
          maxlength="255"
          v-model="link.url"
        >
        </el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        size="small"
        :loading="loading"
        @click="saveLink"
      > Сохранить
      </el-button>
      <el-button size="small" @click="close">Отмена</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "knowledge-base-link-edit-dialog",
  data() {
    return {
      show: false,
      loading: false,
      link: {
        id: null,
        name: null,
        url: null,
      },
      linkRules: {
        name: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
        url: [{required: true, message: 'Поле обязательно для заполнения', trigger: 'blur'}],
      },
    }
  },
  methods: {
    open(link) {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }

      this.loading = false;
      this.link = Object.assign({id: null, name: null, url: null}, link);
      this.show = true;
      this.$nextTick(() => this.$refs.nameToFocus.focus());
    },
    close() {
      this.show = false;
    },
    saveLink() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$refs.editForm.validate()
        .then(() => {
          if (this.link.id) {
            this.updateLink();
          } else {
            this.createLink();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    createLink() {
      this.$api.knowledgeBase.create({
        name: this.link.name,
        url: this.link.url,
      })
        .then(() => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Ссылка успешно создана'
          });
        })
        .finally(() => {
          this.close();
          this.$emit('link-saved');
        })
    },
    updateLink() {
      this.$api.knowledgeBase.update({
        id: this.link.id,
        name: this.link.name,
        url: this.link.url,
      })
        .then(() => {
          this.$notify.success({
            title: 'Обновлено',
            message: 'Ссылка успешно обновлена'
          });
        })
        .finally(() => {
          this.close();
          this.$emit('link-saved');
        })
    }
  }
}
</script>

<style scoped>

</style>